import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as projects from '../../../../projects'
import * as requirement from '../requirement'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: requirement.RESOURCE.payload.dimension.partialId,
      partialId: requirement.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The project this Jira task belongs to, taken from its Jira project.',
    isOptional: true,
    name: 'Project',
    partialId: PartialId.Standard.create('project'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(projects.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
